import { render, staticRenderFns } from "./CommunicationList.vue?vue&type=template&id=651bbb61&scoped=true"
import script from "./CommunicationList.vue?vue&type=script&lang=js"
export * from "./CommunicationList.vue?vue&type=script&lang=js"
import style0 from "./CommunicationList.vue?vue&type=style&index=0&id=651bbb61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651bbb61",
  null
  
)

export default component.exports